import React, { useState } from "react";
import { Link } from "react-router-dom";

const CSAEPolicy = () => {
  const [language, setLanguage] = useState("ko"); // 기본 언어: 한국어

  // 언어별 내용
  const content = {
    en: {
      developer: "Developer: 물가의새",
      title: "Komunity Child Sexual Abuse and Exploitation Prevention Policy",
      lastUpdated: "Last Updated: April 2, 2025",

      introduction: "Introduction",
      introductionText: "At 코뮤니티 (komunity), we are committed to providing a safe environment for all users, especially children. This policy outlines our approach to preventing and addressing child sexual abuse and exploitation (CSAE) content on our platform.",

      zeroTolerance: "1. Zero-Tolerance Policy",
      zeroToleranceText: "We maintain a zero-tolerance policy regarding any content related to child sexual abuse and exploitation. Such content is strictly prohibited on our platform, and we take immediate action when any such content is discovered.",

      prohibited: "2. Prohibited Content",
      prohibitedText: "The following types of content are strictly prohibited on our platform:",
      prohibitedList: [
        "Any visual or textual depiction of child sexual abuse",
        "Content sexualizing minors in any way",
        "Content that promotes, encourages, or facilitates the sexual exploitation of children",
        "Content that depicts minors in a sexually suggestive manner",
        "Content that solicits, advertises, or promotes child sexual abuse material"
      ],

      reporting: "3. Reporting Mechanisms",
      reportingText: "We encourage users to report any suspected CSAE content immediately:",
      reportingList: [
        "In-app reporting: Use the 'Report' button available on all posts and comments",
        "Email: Report directly to our safety team at komunity1011@gmail.com",
        "All reports are treated with utmost priority and confidentiality"
      ],

      enforcement: "4. Enforcement Actions",
      enforcementText: "When CSAE content is identified, we take the following actions:",
      enforcementList: [
        "Immediate removal of the content from our platform",
        "Permanent banning of the user account responsible for posting such content",
        "Reporting to relevant law enforcement agencies, including the Korean National Police Agency's Cyber Investigation Bureau",
        "Preservation of evidence in accordance with applicable laws and regulations"
      ],

      cooperation: "5. Cooperation with Law Enforcement",
      cooperationText: "We actively cooperate with law enforcement agencies in the investigation and prosecution of CSAE cases. This includes:",
      cooperationList: [
        "Reporting detected CSAE content to the relevant authorities",
        "Responding promptly to lawful requests for information",
        "Providing necessary information to assist in the investigation and prosecution of offenders",
        "Participating in industry initiatives aimed at combating CSAE"
      ],

      preventive: "6. Preventive Measures",
      preventiveText: "We implement several preventive measures to minimize the risk of CSAE content appearing on our platform:",
      preventiveList: [
        "Automated content scanning using machine learning technologies",
        "Regular review of reported content by trained moderators",
        "Implementation of strict user verification measures",
        "Continuous monitoring of platform activities for suspicious behavior"
      ],

      education: "7. User Education and Awareness",
      educationText: "We believe in the importance of user education in preventing CSAE. We provide resources to:",
      educationList: [
        "Educate users about the dangers of sharing explicit content involving minors",
        "Provide information about the legal consequences of CSAE",
        "Offer guidance on digital safety for children and parents"
      ],

      review: "8. Regular Policy Review",
      reviewText: "We regularly review and update our CSAE policy to ensure its effectiveness and alignment with international best practices and applicable laws.",

      contact: "9. Contact Information",
      contactText: "For any questions or concerns regarding this policy, please contact our safety team at komunity1011@gmail.com",

      changeLang: "한국어로 변경",
      returnToPrivacy: "Return to Privacy Policy",
    },
    ko: {
      developer: "개발자: 물가의새",
      title: "코뮤니티 아동 성적 학대 및 착취 방지 정책",
      lastUpdated: "최종 업데이트 날짜: 2025년 4월 2일",

      introduction: "소개",
      introductionText: "코뮤니티에서는 모든 사용자, 특히 아동들을 위한 안전한 환경을 제공하기 위해 최선을 다하고 있습니다. 이 정책은 당사 플랫폼에서 아동 성적 학대 및 착취(CSAE) 콘텐츠를 방지하고 대응하는 접근 방식을 설명합니다.",

      zeroTolerance: "1. 무관용 정책",
      zeroToleranceText: "당사는 아동 성적 학대 및 착취와 관련된 모든 콘텐츠에 대해 무관용 정책을 유지합니다. 이러한 콘텐츠는 당사 플랫폼에서 엄격히 금지되며, 발견 시 즉각적인 조치를 취합니다.",

      prohibited: "2. 금지된 콘텐츠",
      prohibitedText: "다음과 같은 유형의 콘텐츠는 당사 플랫폼에서 엄격히 금지됩니다:",
      prohibitedList: [
        "아동 성적 학대에 대한 시각적 또는 텍스트적 묘사",
        "미성년자를 성적으로 표현하는 모든 콘텐츠",
        "아동의 성적 착취를 조장하거나 촉진하는 콘텐츠",
        "미성년자를 성적으로 암시하는 방식으로 묘사하는 콘텐츠",
        "아동 성적 학대 자료를 요청, 광고 또는 홍보하는 콘텐츠"
      ],

      reporting: "3. 신고 메커니즘",
      reportingText: "사용자들이 의심스러운 CSAE 콘텐츠를 즉시 신고할 수 있도록 권장합니다:",
      reportingList: [
        "앱 내 신고: 모든 게시물과 댓글에서 사용 가능한 '신고' 버튼 활용",
        "이메일: komunity1011@gmail.com으로 직접 안전팀에 신고",
        "모든 신고는 최우선 순위와 기밀로 처리됩니다"
      ],

      enforcement: "4. 집행 조치",
      enforcementText: "CSAE 콘텐츠가 확인되면 다음과 같은 조치를 취합니다:",
      enforcementList: [
        "플랫폼에서 해당 콘텐츠 즉시 삭제",
        "해당 콘텐츠를 게시한 사용자 계정 영구 차단",
        "경찰청 사이버수사국 등 관련 법 집행 기관에 신고",
        "관련 법률 및 규정에 따른 증거 보존"
      ],

      cooperation: "5. 법 집행 기관과의 협력",
      cooperationText: "당사는 CSAE 사례의 조사 및 기소에 있어 법 집행 기관과 적극적으로 협력합니다:",
      cooperationList: [
        "감지된 CSAE 콘텐츠를 관련 당국에 신고",
        "합법적인 정보 요청에 신속하게 대응",
        "범죄자의 조사 및 기소를 지원하기 위해 필요한 정보 제공",
        "CSAE 퇴치를 위한 업계 이니셔티브에 참여"
      ],

      preventive: "6. 예방 조치",
      preventiveText: "당사는 플랫폼에 CSAE 콘텐츠가 나타날 위험을 최소화하기 위해 여러 예방 조치를 시행합니다:",
      preventiveList: [
        "기계 학습 기술을 활용한 자동 콘텐츠 스캐닝",
        "훈련된 모더레이터에 의한 신고된 콘텐츠의 정기적 검토",
        "엄격한 사용자 인증 조치 구현",
        "의심스러운 행동에 대한 플랫폼 활동 지속적 모니터링"
      ],

      education: "7. 사용자 교육 및 인식",
      educationText: "당사는 CSAE 방지에 있어 사용자 교육의 중요성을 믿습니다. 다음과 같은 자원을 제공합니다:",
      educationList: [
        "미성년자와 관련된 명시적 콘텐츠 공유의 위험성에 대한 사용자 교육",
        "CSAE의 법적 결과에 대한 정보 제공",
        "아동 및 부모를 위한 디지털 안전에 대한 지침 제공"
      ],

      review: "8. 정기적인 정책 검토",
      reviewText: "당사는 CSAE 정책의 효과성과 국제 모범 사례 및 관련 법률과의 일치성을 보장하기 위해 정기적으로 검토하고 업데이트합니다.",

      contact: "9. 연락처 정보",
      contactText: "이 정책에 관한 질문이나 우려사항이 있으시면 komunity1011@gmail.com 으로 안전팀에 문의하십시오.",

      changeLang: "Change to English",
      returnToPrivacy: "개인정보처리방침으로 돌아가기",
    },
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
        <button
          onClick={() => setLanguage(language === "en" ? "ko" : "en")}
          style={{
            padding: "8px 12px",
            backgroundColor: "#4527A0",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginBottom: "20px"
          }}
        >
          {content[language].changeLang}
        </button>

        <Link to="/komunity-privacyPolicy">
          <button style={{
            padding: "8px 12px",
            backgroundColor: "#FF5722",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}>
            {content[language].returnToPrivacy}
          </button>
        </Link>
      </div>

      <h1 style={{ color: "#000000" }}>{content[language].developer}</h1>
      <h1 style={{ color: "#4527A0" }}>{content[language].title}</h1>
      <p style={{ fontStyle: "italic", color: "#666" }}>{content[language].lastUpdated}</p>

      <h2 style={{ color: "#333" }}>{content[language].introduction}</h2>
      <p>{content[language].introductionText}</p>

      <h2 style={{ color: "#333" }}>{content[language].zeroTolerance}</h2>
      <p>{content[language].zeroToleranceText}</p>

      <h2 style={{ color: "#333" }}>{content[language].prohibited}</h2>
      <p>{content[language].prohibitedText}</p>
      <ul>
        {content[language].prohibitedList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].reporting}</h2>
      <p>{content[language].reportingText}</p>
      <ul>
        {content[language].reportingList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].enforcement}</h2>
      <p>{content[language].enforcementText}</p>
      <ul>
        {content[language].enforcementList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].cooperation}</h2>
      <p>{content[language].cooperationText}</p>
      <ul>
        {content[language].cooperationList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].preventive}</h2>
      <p>{content[language].preventiveText}</p>
      <ul>
        {content[language].preventiveList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].education}</h2>
      <p>{content[language].educationText}</p>
      <ul>
        {content[language].educationList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].review}</h2>
      <p>{content[language].reviewText}</p>

      <h2 style={{ color: "#333" }}>{content[language].contact}</h2>
      <p>{content[language].contactText}</p>


      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <Link to="/" style={{
          textDecoration: "none",
          color: "#4527A0",
          fontWeight: "bold",
          fontSize: "14px"
        }}>
          ← Back to App Selection
        </Link>
      </div>
    </div>
  );
};

export default CSAEPolicy;